import {useQuery} from 'react-query';
import {FolderType, Media} from '../types';
import {useMediaPlayer} from './useMediaPlayer';
import {useRef, useState} from 'react';
import {TextInput} from 'react-native-gesture-handler';
import {useAppDispatch} from '../store/hooks';
import {
  getById as getByIdMain,
  writeItem as writeItemMain,
  getFolderContent as getFolderContentMain,
} from '../api';
import {useFolderMutations} from './useFolderMutations';
import {useClickFile} from './useClickFile';

export function useFolder(
  folderId: string,
  getFolderContentProxy:
    | ((folderId: string) => Promise<[]>)
    | undefined,
  getByIdProxy: ((folderId: string) => Promise<any>) | undefined,
  folderType: FolderType,
  writeItemProxy?: any,
  mnemonic?: string,
  title?: string,
  userId?: string,
) {
  const getFolderContent =
    getFolderContentProxy || getFolderContentMain;
  const getById = getByIdProxy || getByIdMain;
  const writeItem = writeItemProxy || writeItemMain;
  const queryKey = 'folderContent_' + folderId;
  const folderContentQuery = useQuery(
    queryKey,
    async () => {
      // console.info('useFolder', folderId, mnemonic);
      let folder;
      try {
        folder = await getById(folderId);
        // console.info('folder', folder);
      } catch (err) {
        console.error(err);
      }
      // console.info('mnemonic', mnemonic, title);
      if (mnemonic && title && !folder?.id) {
        folder = await writeItem({
          id: folderId,
          mnemonic,
          title,
          isFolder: true,
          folderId: 'new_' + folderType,
          folderType,
          userId,
        });
        // console.info('after create new folder, nf', folder);
      }
      // console.info('folder', folder);
      const content = await getFolderContent(folderId);
      return {folder, content};
    },
    {
      refetchOnWindowFocus: true,
      refetchOnMount: true,
    },
  );
  const mediaPlayer = useMediaPlayer(folderId, folderContentQuery);
  const folderContent = folderContentQuery.data?.content;
  const folder = folderContentQuery.data?.folder;
  const isLoadingFolderContent = folderContentQuery.isFetching;
  const folderFiles =
    folder && folder.files
      ? (folder?.files?.map((file: string) => ({
          id: file,
          url: file,
          title: file,
          filename: file,
          isMediaNew: true,
          folderId: folder!.id,
          _id: file,
          date: (folder! as any as Media).date,
          originalId: (folder! as any as Media).originalId,
          webpage_url: (folder! as any as Media).webpage_url,
          thumbnail: (folder! as any as Media).thumbnail,
          extractor: (folder! as any as Media).extractor,
        })) as Media[])
      : [];
  const folderNameInputRef = useRef<TextInput | null>(null);
  const [currentFolderEditorName, setFolderEditorName] = useState('');

  const content =
    isLoadingFolderContent || folderContent === undefined
      ? undefined
      : folderFiles.concat(folderContent!);

  const mutations = useFolderMutations(
    folderType,
    content,
    folderContentQuery,
  );

  const {onClickFile} = useClickFile();
  const isEncoderProject = false;
  const addMedia = () =>
    onClickFile(folderId, isEncoderProject, userId as string);
  return {
    ...mutations,
    isLoadingFolderContentError: folderContentQuery.error,
    isLoadingFolderContent,
    isLoadingFolder: isLoadingFolderContent,
    folderContentQuery,
    folder,
    folderContent: content,
    folderNameInputRef,
    currentFolderEditorName,
    setFolderEditorName,
    folderType,
    getContentItem: (_data: unknown, index: number) =>
      (content as Media[])[index],
    getContentCount: () => content?.length || 0,
    ...mediaPlayer,
    addMedia,
  };
}
